import React, { Component } from "react";
import { Container } from "semantic-ui-react";
import { firebase } from "../../../firebase";
import "./styles/styles.css";
import Spinner from "../../Spinner/Spinner";
import Error from "../../Error/error";

class New extends Component {
  constructor() {
    super();
    this.state = {
      url: "",
      loading: true,
      error: false,
      New: ""
    };
  }
  UNSAFE_componentWillMount() {
    const docRef = firebase
      .firestore()
      .collection("news")
      .doc(window.location.href.split("/")[4]);

    docRef
      .get()
      .then(querySnapshot => {
        if (querySnapshot.data()) {
          this.setState(() => ({
            loading: false,
            New: querySnapshot.data(),
            error: false
          }));
        } else {
          this.setState(() => ({ loading: false, error: true }));
        }
      })
      .catch(error => {
        this.setState({ error: true, loading: false });
      });
  }

  render() {
    const { content, date, image, tittle } = this.state.New;
    let message;
    let dateNew;
    if (date) {
      const toDate = date.toDate();
      dateNew = toDate.toLocaleDateString();
    }

    if (this.state.loading === true) {
      message = (
        <div className="Spinner">
          <Spinner />
        </div>
      );
    } else if (this.state.error === true) {
      message = (
        <div className="error">
          ><Error />
        </div>
      );
    } else {
      message = (
        <center>
          <Container
            style={{
              marginTop: 150,
              marginBottom: 150
            }}
          >
            <div className="col-lg-10 col-md-6 col-12 text-center pb-5">
              <div className="pb-4">
                <center>
                  <h1 className="tittle">{tittle}</h1>
                  <br></br>
                  <div
                    className="new customizableImage"
                    style={{
                      backgroundImage: `url(${image})`
                    }}
                  ></div>
                </center>
              </div>
              <div>
                <br></br>
                <h5 className="Description dateNew">Publicado:{dateNew}</h5>
                <p className="Description textDescription">{content}</p>
              </div>
            </div>
          </Container>
        </center>
      );
    }

    return <>{message}</>;
  }
}

export default New;
